export default [
    {
      "terpene_type_id": "terpene-cbeea764-a1fa-4186-955d-aed28bcc62d1",
      "terpene_name_en": "alpha-Bisabolol"
    },
    {
      "terpene_type_id": "terpene-05ee2495-b193-485f-8f68-d8bc4c81285b",
      "terpene_name_en": "Borneol"
    },
    {
      "terpene_type_id": "terpene-2a4fea53-4d87-4f5c-a9c4-1089d9b08f95",
      "terpene_name_en": "Caryophyllene"
    },
    {
      "terpene_type_id": "terpene-53dbb259-3528-4cc1-954b-304e2bf2d953",
      "terpene_name_en": "Linalool"
    },
    {
      "terpene_type_id": "terpene-4f5cf38c-99a2-4203-a798-a98354414696",
      "terpene_name_en": "Limonene"
    },
    {
      "terpene_type_id": "terpene-ac9675b8-0b86-43cf-b0a3-292f25d57811",
      "terpene_name_en": "Pinene"
    },
    {
      "terpene_type_id": "terpene-9c916095-6a98-404a-b814-52a2e2679e3b",
      "terpene_name_en": "Myrcene"
    },
    {
      "terpene_type_id": "terpene-190332ec-ac23-43b4-a579-7297bd681d54",
      "terpene_name_en": "Humulene"
    },
    {
      "terpene_type_id": "terpene-24bb753c-41b4-41cd-b20e-0c217610e3fa",
      "terpene_name_en": "Eucalyptol"
    },
    {
      "terpene_type_id": "terpene-d62d15e8-f30f-4d6d-b03a-6fa75f1c2a98",
      "terpene_name_en": "Ocimene"
    }
  ]